const WIDTH = window.innerWidth;
const HEIGHT = window.innerHeight;
const isSmallDevice = WIDTH <= 375;
const WEB = window.innerWidth > 768;

export { WIDTH, HEIGHT, isSmallDevice, WEB };
